import axios from 'axios'
import i18n from '@/i18n'
const baseURL = process.env.VUE_APP_AUTH_SERVER + '/api/users'

export default {
  namespaced: true,
  state: {
    lang: localStorage.getItem('etalon-admin-locale') || 'ua',
    lang_list: ['ua', 'ru']
  },
  mutations: {
    setLang (state, value) {
      value = value === 'ru' ? 'ru' : 'ua'
      localStorage.setItem('etalon-admin-locale', value)
      state.lang = value
      i18n.locale = value
      axios.defaults.headers.localization = value
    }
  },
  actions: {
    changeUserLang ({ commit, rootState }, lang) {
      axios.put(baseURL, {
        lang: lang
      }).then(res => {
      })
    }
  }
}
